<template>
    <div class="in_warehouse_management_wrap">
        <el-tabs v-model="activeName" @tab-click="handleClickTab" >
            <el-tab-pane  label="待入库" name="1" >
                  <span slot="label">
                      <span>待入库</span>
                      <el-badge :value="pendingTotal > 99 ? '99+' : pendingTotal" v-if="pendingTotal>0" size="mini" class="item"></el-badge>
                 </span>
                <div class="in_warehouse_management_top">
                    <div class="search_left">
                        <el-input size="small" v-model="pending_keywords" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickEnter('inputPendingRef')" ref="inputPendingRef" @blur="handleClickSearch">
                            <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                        </el-input>
                        <el-popover placement="right-start" width="500" trigger="click" @hide="handleClickSearch">
                            <div class="search_container">
                                <div class="search_top_container">
                                    <span class="title">筛选</span>
                                    <el-button @click="handleClickReset" size="mini" :disabled="pendingSearchFilterList.findIndex(find => isValid(find.field_value)) > -1 ? false : true">清空筛选条件</el-button>
                                </div>
                                <div class="search_bottom_container">
                                    <ul>
                                        <li v-for="item in pendingSearchFilterList">
                                            <div>
                                                <el-select size="small" v-model="item.field_key" disabled>
                                                    <el-option label="入库类型" value="stock_type"></el-option>
                                                    <el-option label="入库状态" value="status"></el-option>
                                                    <el-option label="发起人"   value="uid"></el-option>
                                                    <el-option label="发起单据日期" value="date_range"></el-option>
                                                </el-select>
                                            </div>
                                            <div class="search_filter_type">
                                                <el-select size="small" v-model="item.field_type" disabled>
                                                    <el-option label="满足" value="eq"></el-option>
                                                    <el-option label="不满足" value="neq"></el-option>
                                                </el-select>
                                            </div>
                                            <div>
                                                <template v-if="item.field_key == 'stock_type'">
                                                    <el-select clearable placeholder="请选择入库类型" size="small" v-model="item.field_value"  filterable remote reserve-keyword>
                                                        <el-option :label="item.stock_type_name" :value="item.stock_type" v-for="item in inTypeList.filter(find => find.stock_type != 'general')"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'status'">
                                                    <el-select clearable  placeholder="请选择入库状态" size="small" v-model="item.field_value" >
                                                        <el-option label="待入库" value="0" ></el-option>
                                                        <el-option label="部分入库" value="2" ></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'uid'">
                                                    <el-select clearable placeholder="请选择发起人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                        <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'date_range'">
                                                    <el-date-picker  v-model="item.field_value" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                                </template>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <el-button size="small" slot="reference" class="custom_popover_button">
                                <i class="iconfont icon-shaixuan"></i>
                                <span class="search_filter_length" v-if="pendingSearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <span  v-text="pendingSearchFilterList.filter(find => isValid(find.field_value)).length + '个条件'"></span>
                                    <i class="el-icon-error" @click="handleClickReset"></i>
                                </span>
                            </el-button>
                        </el-popover>
                    </div>

                    <div class="handle_right">
                        <el-button type="primary" size="small" @click="handleClickAdd">新建入库</el-button>
                    </div>

                </div>
                <div class="in_warehouse_management_bottom">
                    <CustomVxeTable v-if="activeName == 1"
                           :loading="loading"
                            ref="pendingTableRef"
                            class="custom-table"
                            id="pendingInWarehouseTable"
                            :autoResize="true"
                            :tableData="tableData"
                            :reduceHeight="reduceHeight"
                            :isShowToolBar="true"
                            :empty-render="{ name: 'NotData' }"
                            :pagination.sync="pagination"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                            :customConfig="tableCustomConfig">
                        <vxe-column field="approval_id" title="审批编号"  width="120" show-overflow>
                            <template #default="{ row }">
                                <span v-if="row.approval_id > 0" class="link-label" @click="handleClickApprovalDetail(row)" v-text="row.approval_id"></span>
                                <span v-else>--</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="approval_set_name" title="入库类型"  min-width="140" show-overflow></vxe-column>
                        <vxe-column field="related_num" title="业务编号"  width="152" show-overflow>
                            <template #default="{ row }">
                                <span v-if="row.related_info && row.related_info.related_num" class="link-label" @click="handleClickRelatedDetail(row)" v-text="row.related_info.related_num"></span>
                                <span v-else>--</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="status" title="入库状态"  width="100" show-overflow>
                            <template #default="{ row }">
                                <span class="status_code status_code0"  v-if="row.status == 0 ">待入库</span>
                                <span class="status_code status_code1"  v-if="row.status == 1 ">已取消</span>
                                <span class="status_code status_code2"  v-if="row.status == 2 ">部分入库</span>
                                <span class="status_code status_code3"  v-if="row.status == 3 ">全部入库</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="products" title="待入库产品" min-width="300px"  show-overflow>
                            <template #default="{ row }">
                                <el-tooltip popper-class="custom_tooltip" effect="dark" placement="top-start" v-if="row.products && row.products.length>0">
                                    <div slot="content" class="log_products_list custom_tooltip_wrap">
                                        <p v-for="item in row.products" v-text="item" class="ellipsis_2"></p>
                                    </div>
                                    <div class="flexLeftAutoRight ellipsis tooltip_log_class" >
                                        <p  class="leftText ellipsis">
                                            <span   v-text="row.products[0]"></span>
                                        </p>
                                        <span  class="rightText" v-if="row.products.length > 1" v-text="'+'+ row.products.length"></span>
                                    </div>
                                </el-tooltip>
                            </template>
                        </vxe-column>
                        <vxe-column field="creator_info" title="发起人"  width="108" show-overflow>
                            <template #default="{ row }">
                                <userDetailPopover v-if="row.creator_info" :uid="row.creator_info.id">
                                    <div slot="container">
                                        <div class="user_head">
                                            <img :src="row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                            <span v-text="row.creator_info.name"></span>
                                        </div>
                                    </div>
                                </userDetailPopover>
                            </template>
                        </vxe-column>
                        <vxe-column field="created_at" title="发起单据日期"  width="155" show-overflow></vxe-column>
                        <vxe-column field="operate" width="160" fixed="right">
                            <template #header>
                                <span>操作</span>
                                <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                    <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                                </el-tooltip>
                            </template>
                            <template #default="{ row }">
                                <div class="table-operate-icon">
                                    <el-button type="text" @click="handleClickInAudit(row)">审核入库</el-button>
                                    <span v-if="row.biz_type != 'purchase' && row.biz_type != 'order' &&  row.stock_type != 'transfer_in_cancel' " class="line" style="margin-top: -3px"></span>
                                    <el-button v-if="row.biz_type != 'purchase' && row.biz_type != 'order' &&  row.stock_type != 'transfer_in_cancel' " type="text" @click="handleClickInCancel(row)" class="danger_text">取消入库</el-button>
                                </div>
                            </template>
                        </vxe-column>
                        <template #empty>
                            <div class="custom-table-empty">
                                <template v-if="pending_keywords || pendingSearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <div class="custom-table-empty-img">
                                        <img src="https://download.hecoos.com/enlightv/2025-09/396f6b4018a1fa0cb9cbaa6696b8b68f.png" alt="">
                                    </div>
                                    <p class="custom-table-empty-txt">暂无搜索结果，请重新输入</p>
                                </template>
                                <template v-else>
                                    <div class="custom-table-empty-img">
                                        <img src="https://download.hecoos.com/enlightv/2024-53/147a907c1ec9fd000d8e8b0b30dd0fba.svg" alt="">
                                    </div>
                                    <p class="custom-table-empty-txt">暂无数据</p>
<!--                                    <div>-->
<!--                                        <el-button type="primary" plain size="small" @click="handleClickAdd">新建入库</el-button>-->
<!--                                    </div>-->
                                </template>
                            </div>
                        </template>
                    </CustomVxeTable>
                </div>
            </el-tab-pane>
            <el-tab-pane  label="已入库" name="2" >
                <div class="in_warehouse_management_top">
                    <div class="search_left">
                        <el-input size="small" v-model="already_keywords" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch" @keyup.enter.native="handleClickEnter('inputAlreadyRef')" ref="inputAlreadyRef" @blur="handleClickSearch">
                            <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                        </el-input>
                        <el-popover placement="right-start" width="500" trigger="click" @hide="handleClickSearch">
                            <div class="search_container">
                                <div class="search_top_container">
                                    <span class="title">筛选</span>
                                    <el-button @click="handleClickReset" size="mini" :disabled="alreadySearchFilterList.findIndex(find => isValid(find.field_value)) > -1 ? false : true">清空筛选条件</el-button>
                                </div>
                                <div class="search_bottom_container">
                                    <ul>
                                        <li v-for="item in alreadySearchFilterList">
                                            <div>
                                                <el-select size="small" v-model="item.field_key" disabled>
                                                    <el-option label="入库类型" value="stock_type"></el-option>
                                                    <el-option label="入库仓库" value="stock_id"></el-option>
                                                    <el-option label="发起人"   value="uid"></el-option>
                                                    <el-option label="处理人"   value="handle_uid"></el-option>
                                                    <el-option label="发起单据日期" value="date_range"></el-option>
                                                </el-select>
                                            </div>
                                            <div class="search_filter_type">
                                                <el-select size="small" v-model="item.field_type" disabled>
                                                    <el-option label="满足" value="eq"></el-option>
                                                    <el-option label="不满足" value="neq"></el-option>
                                                </el-select>
                                            </div>
                                            <div>
                                                <template v-if="item.field_key == 'stock_type'">
                                                    <el-select clearable placeholder="请选择入库类型" size="small" v-model="item.field_value"  filterable remote reserve-keyword >
                                                        <el-option :label="item.stock_type_name" :value="item.stock_type" v-for="item in inTypeList"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'stock_id'">
                                                    <el-select clearable  placeholder="请选择入库仓库" size="small" v-model="item.field_value" >
                                                        <el-option :label="item.name" :value="item.id" v-for="item in stockList"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'uid'">
                                                    <el-select clearable placeholder="请选择发起人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                        <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'handle_uid'">
                                                    <el-select clearable placeholder="请选择处理人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                        <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'date_range'">
                                                    <el-date-picker  v-model="item.field_value" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                                </template>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <el-button size="small" slot="reference" class="custom_popover_button">
                                <i class="iconfont icon-shaixuan"></i>
                                <span class="search_filter_length" v-if="alreadySearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <span  v-text="alreadySearchFilterList.filter(find => isValid(find.field_value)).length + '个条件'"></span>
                                    <i class="el-icon-error" @click="handleClickReset"></i>
                                </span>
                            </el-button>
                        </el-popover>
                    </div>

                    <div class="handle_right">
                        <el-button type="primary" size="small" @click="handleClickAdd">新建入库</el-button>
                    </div>

                </div>
                <div class="in_warehouse_management_bottom">
                    <CustomVxeTable v-if="activeName == 2"
                            ref="alreadyTableRef"
                            :loading="loading"
                            class="custom-table"
                            id="alreadyInWarehouseTable"
                            :autoResize="true"
                            :tableData="tableData"
                            :reduceHeight="reduceHeight"
                            :isShowToolBar="true"
                            :empty-render="{ name: 'NotData' }"
                            :pagination.sync="pagination"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                            :customConfig="tableCustomConfig">
                        <vxe-column field="approval_id" title="审批编号"  width="120" show-overflow>
                            <template #default="{ row }">
                                <span v-if="row.approval_id > 0" class="link-label" @click="handleClickApprovalDetail(row)" v-text="row.approval_id"></span>
                                <span v-else>--</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="log_num" title="入库单编号"  min-width="150" show-overflow>
                            <template #default="{ row }">
                                <span class="link-label" @click="handleClickInDetail(row)" v-text="row.log_num"></span>
                            </template>
                        </vxe-column>
                        <vxe-column field="approval_set_name" title="入库类型"  min-width="140" show-overflow></vxe-column>
                        <vxe-column field="uid" title="业务编号"  width="152" show-overflow>
                            <template #default="{ row }">
                                <span v-if="row.related_info && row.related_info.related_num" class="link-label" @click="handleClickRelatedDetail(row)" v-text="row.related_info.related_num"></span>
                                <span v-else>--</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="log_products" title="入库产品" min-width="140px"  >
                            <template #default="{ row }">
                                <el-tooltip  effect="dark" popper-class="custom_tooltip" placement="top-start" v-if="row.log_products && row.log_products.length>0">
                                    <div slot="content" class="log_products_list custom_tooltip_wrap">
                                        <p v-for="item in row.log_products" v-text="item" class="ellipsis_2"></p>
                                    </div>
                                    <div class="flexLeftAutoRight ellipsis tooltip_log_class" >
                                        <p  class="leftText ellipsis">
                                            <span   v-text="row.log_products[0]"></span>
                                        </p>
                                        <span  class="rightText" v-if="row.log_products.length > 1" v-text="'+'+ row.log_products.length"></span>
                                    </div>
                                </el-tooltip>
                            </template>
                        </vxe-column>
                        <vxe-column field="stocks" title="入库仓库"  width="108" show-overflow>
                            <template #default="{ row }">
                                <el-tooltip  effect="dark" popper-class="custom_tooltip" placement="top-start" v-if="row.stocks && row.stocks.length>0">
                                    <div slot="content" class="log_products_list custom_tooltip_wrap">
                                        <p v-for="item in row.stocks" v-text="item" class="ellipsis_2"></p>
                                    </div>
                                    <div class="flexLeftAutoRight ellipsis tooltip_log_class" >
                                        <p  class="leftText ellipsis">
                                            <span   v-text="row.stocks[0]"></span>
                                        </p>
                                        <span  class="rightText" v-if="row.stocks.length > 1" v-text="'+'+ row.stocks.length"></span>
                                    </div>
                                </el-tooltip>
                            </template>
                        </vxe-column>

                        <vxe-column field="approval_user" title="发起人"  width="108" show-overflow>
                            <template #default="{ row }">
                                <userDetailPopover v-if="row.approval_user" :uid="row.approval_user.id">
                                    <div slot="container">
                                        <div class="user_head">
                                            <img :src="row.approval_user && row.approval_user.avatar ? row.approval_user.avatar : defaultImg" alt="" />
                                            <span v-text="row.approval_user.name"></span>
                                        </div>
                                    </div>
                                </userDetailPopover>
                            </template>
                        </vxe-column>
                        <vxe-column field="creator_info" title="处理人"  width="108" show-overflow>
                            <template #default="{ row }">
                                <userDetailPopover v-if="row.creator_info" :uid="row.creator_info.id">
                                    <div slot="container">
                                        <div class="user_head">
                                            <img :src="row.creator_info && row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                            <span v-text="row.creator_info.name"></span>
                                        </div>
                                    </div>
                                </userDetailPopover>
                            </template>
                        </vxe-column>
                        <vxe-column field="created_at" title="入库日期"  width="135" show-overflow></vxe-column>
                        <vxe-column field="operate" width="90" fixed="right">
                            <template #header>
                                <span>操作</span>
                                <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                    <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                                </el-tooltip>
                            </template>
                            <template #default="{ row }">
                                <div class="table-operate-icon">
                                    <el-button type="text" @click="handleClickInDetail(row)">详情</el-button>
                                </div>
                            </template>
                        </vxe-column>
                        <template #empty>
                            <div class="custom-table-empty">
                                <template v-if="already_keywords || alreadySearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <div class="custom-table-empty-img">
                                        <img src="https://download.hecoos.com/enlightv/2025-09/396f6b4018a1fa0cb9cbaa6696b8b68f.png" alt="">
                                    </div>
                                    <p class="custom-table-empty-txt">暂无搜索结果，请重新输入</p>
                                </template>
                                <template v-else>
                                    <div class="custom-table-empty-img">
                                        <img src="https://download.hecoos.com/enlightv/2024-53/147a907c1ec9fd000d8e8b0b30dd0fba.svg" alt="">
                                    </div>
                                    <p class="custom-table-empty-txt">暂无数据</p>
<!--                                    <div>-->
<!--                                        <el-button type="primary" plain size="small" @click="handleClickAdd">新建入库</el-button>-->
<!--                                    </div>-->
                                </template>
                            </div>
                        </template>
                    </CustomVxeTable>
                </div>
            </el-tab-pane>
            <el-tab-pane  label="已取消" name="3" >
                <div class="in_warehouse_management_top">
                    <div class="search_left">
                        <el-input size="small" v-model="cancel_keywords" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickEnter('inputCancelRef')" ref="inputCancelRef" @blur="handleClickSearch">
                            <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                        </el-input>
                        <el-popover placement="right-start" width="500" trigger="click" @hide="handleClickSearch">
                            <div class="search_container">
                                <div class="search_top_container">
                                    <span class="title">筛选</span>
                                    <el-button @click="handleClickReset" size="mini" :disabled="cancelSearchFilterList.findIndex(find => isValid(find.field_value)) > -1 ? false : true">清空筛选条件</el-button>
                                </div>
                                <div class="search_bottom_container">
                                    <ul>
                                        <li v-for="item in cancelSearchFilterList">
                                            <div>
                                                <el-select size="small" v-model="item.field_key" disabled>
                                                    <el-option label="入库类型" value="stock_type"></el-option>
                                                    <el-option label="发起人"   value="uid"></el-option>
                                                    <el-option label="处理人"   value="cancel_uid"></el-option>
                                                    <el-option label="取消入库日期" value="cancel_at"></el-option>
                                                    <el-option label="取消原因" value="reason"></el-option>
                                                </el-select>
                                            </div>
                                            <div class="search_filter_type">
                                                <el-select size="small" v-model="item.field_type" disabled>
                                                    <el-option label="满足" value="eq"></el-option>
                                                    <el-option label="不满足" value="neq"></el-option>
                                                </el-select>
                                            </div>
                                            <div>
                                                <template v-if="item.field_key == 'stock_type'">
                                                    <el-select clearable placeholder="请选择入库类型" size="small" v-model="item.field_value"  filterable remote reserve-keyword >
                                                        <el-option :label="item.stock_type_name" :value="item.stock_type" v-for="item in inTypeList.filter(find => find.stock_type != 'general')"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'uid'">
                                                    <el-select clearable placeholder="请选择发起人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                        <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'cancel_uid'">
                                                    <el-select clearable placeholder="请选择处理人" size="small" v-model="item.field_value" filterable remote reserve-keyword  :remote-method="getUserList">
                                                        <el-option :label="item.name" :value="item.uid" v-for="item in userList"></el-option>
                                                    </el-select>
                                                </template>

                                                <template v-if="item.field_key == 'cancel_at'">
                                                    <el-date-picker  v-model="item.field_value" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                                                </template>

                                                <template v-if="item.field_key == 'reason'">
                                                    <el-input v-model="item.field_value" size="small"  placeholder="请输入取消原因"></el-input>
                                                </template>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <el-button size="small" slot="reference" class="custom_popover_button">
                                <i class="iconfont icon-shaixuan"></i>
                                <span class="search_filter_length" v-if="cancelSearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <span  v-text="cancelSearchFilterList.filter(find => isValid(find.field_value)).length + '个条件'"></span>
                                    <i class="el-icon-error" @click="handleClickReset"></i>
                                </span>
                            </el-button>
                        </el-popover>
                    </div>

                    <div class="handle_right">
                        <el-button type="primary" size="small" @click="handleClickAdd">新建入库</el-button>
                    </div>

                </div>
                <div class="in_warehouse_management_bottom">
                    <CustomVxeTable v-if="activeName == 3"
                            :loading="loading"
                            ref="cancelTableRef"
                            class="custom-table"
                            id="cancelInWarehouseTable"
                            :autoResize="true"
                            :tableData="tableData"
                            :reduceHeight="reduceHeight"
                            :isShowToolBar="true"
                            :empty-render="{ name: 'NotData' }"
                            :pagination.sync="pagination"
                            @handleCurrentChange="handleCurrentChange"
                            @handleSizeChange="handleSizeChange"
                            :customConfig="tableCustomConfig">
                        <vxe-column field="name" title="审批编号"  width="120" show-overflow>
                            <template #default="{ row }">
                                <span v-if="row.approval_id > 0" class="link-label" @click="handleClickApprovalDetail(row)" v-text="row.approval_id"></span>
                                <span v-else>--</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="approval_set_name" title="入库类型"  min-width="140" show-overflow></vxe-column>
                        <vxe-column field="products" title="取消入库产品" min-width="260px"  show-overflow>
                            <template #default="{ row }">
                                <el-tooltip  effect="dark" popper-class="custom_tooltip" placement="top-start" v-if="row.products && row.products.length>0">
                                    <div slot="content" class="log_products_list custom_tooltip_wrap">
                                        <p v-for="item in row.products" v-text="item" class="ellipsis_2"></p>
                                    </div>
                                    <div class="flexLeftAutoRight ellipsis tooltip_log_class" >
                                        <p  class="leftText ellipsis">
                                            <span   v-text="row.products[0]"></span>
                                        </p>
                                        <span  class="rightText" v-if="row.products.length > 1" v-text="'+'+ row.products.length"></span>
                                    </div>
                                </el-tooltip>
                            </template>
                        </vxe-column>
                        <vxe-column field="user_avatar" title="发起人"  width="108" show-overflow>
                            <template #default="{ row }">
                                <userDetailPopover v-if="row.creator_info" :uid="row.creator_info.id">
                                    <div slot="container">
                                        <div class="user_head">
                                            <img :src="row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                            <span v-text="row.creator_info.name"></span>
                                        </div>
                                    </div>
                                </userDetailPopover>
                            </template>
                        </vxe-column>
                        <vxe-column field="cancel_uid" title="处理人"  width="108" show-overflow>
                            <template #default="{ row }">
                                <userDetailPopover v-if="row.cancel_info" :uid="row.cancel_info.id">
                                    <div slot="container">
                                        <div class="user_head">
                                            <img :src="row.cancel_info.avatar ? row.cancel_info.avatar : defaultImg" alt="" />
                                            <span v-text="row.cancel_info.name"></span>
                                        </div>
                                    </div>
                                </userDetailPopover>
                            </template>
                        </vxe-column>


                        <vxe-column field="cancel_at" title="取消入库日期"  width="155" show-overflow></vxe-column>
                        <vxe-column field="reason" title="取消原因"  width="190" show-overflow></vxe-column>
                        <vxe-column field="operate" width="90" fixed="right">
                            <template #header>
                                <span>操作</span>
                                <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                    <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                                </el-tooltip>
                            </template>
                            <template #default="{ row }">
                                <div class="table-operate-icon">
                                    <el-button type="text" @click="handleClickInCancelDetail(row)">详情</el-button>
                                </div>
                            </template>
                        </vxe-column>
                        <template #empty>
                            <div class="custom-table-empty">
                                <template v-if="cancel_keywords || cancelSearchFilterList.filter(find => isValid(find.field_value)).length">
                                    <div class="custom-table-empty-img">
                                        <img src="https://download.hecoos.com/enlightv/2025-09/396f6b4018a1fa0cb9cbaa6696b8b68f.png" alt="">
                                    </div>
                                    <p class="custom-table-empty-txt">暂无搜索结果，请重新输入</p>
                                </template>
                                <template v-else>
                                    <div class="custom-table-empty-img">
                                        <img src="https://download.hecoos.com/enlightv/2024-53/147a907c1ec9fd000d8e8b0b30dd0fba.svg" alt="">
                                    </div>
                                    <p class="custom-table-empty-txt">暂无数据</p>
<!--                                    <div>-->
<!--                                        <el-button type="primary" plain size="small" @click="handleClickAdd">新建入库</el-button>-->
<!--                                    </div>-->
                                </template>
                            </div>
                        </template>
                    </CustomVxeTable>
                </div>
            </el-tab-pane>
        </el-tabs>
        <InCancelProductDetailDialog :inColumnId="inColumnId" :inCancelProductDetailDialog.sync="inCancelProductDetailDialog" v-if="inCancelProductDetailDialog"/>
        <InProductDetail :inProductDetailDialog.sync="inProductDetailDialog" v-if="inProductDetailDialog" :inColumnId="inColumnId"></InProductDetail>
        <InCancelProduct :inCancelDialog.sync="inCancelDialog" v-if="inCancelDialog" :inColumnId="inColumnId" :inColumnInfo="inColumnInfo" @success="handleClickSearch"></InCancelProduct>
        <PurchaseDetail :purchaseDetailVisible.sync="purchaseDetailVisible" v-if="purchaseDetailVisible" :purchaseId="relatedId"/>
    </div>
</template>

<script>
import {stockInList,stockList,GetUserList,stockPendingInList,stockPendingInCancelList,getStockType,getStockLogList,getPendingList,getPendingCancelList} from "@/api"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import InCancelProductDetailDialog from "./component/in_cancel_product_detail"; //取消入库详情
import InCancelProduct from "./component/in_cancel_product"; //取消入库
import InProductDetail from "../component/in_product_detail" //入库详情
import PurchaseDetail from "../../Purchase/component/purchase_detail"; //采购详情
import {EventBus} from '@/utils/eventBus';
export default {
    name: "InWarehouseManagement",
    components: {
        CustomVxeTable,
        userDetailPopover,
        InCancelProductDetailDialog,
        InCancelProduct,
        InProductDetail,
        PurchaseDetail
    },
    data() {
        return {
            loading:false,
            defaultImg: require("@/assets/images/default.jpg"),
            activeName:'1',
            pending_keywords:'',
            already_keywords:'',
            cancel_keywords:'',
            tableData:[],
            tableHeight:'',
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "checkbox";
                },
                allowSort: true,
            },

            pendingSearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '入库类型',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'status',
                    field_name: '入库状态',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'uid',
                    field_name: '发起人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'date_range',
                    field_name: '发起单据日期',
                    field_value: [],
                    field_type: 'eq',
                },
            ],
            alreadySearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '入库类型',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'stock_id',
                    field_name: '入库仓库',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'uid',
                    field_name: '发起人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'handle_uid',
                    field_name: '处理人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'date_range',
                    field_name: '发起单据日期',
                    field_value: '',
                    field_type: 'eq',
                },
            ],
            cancelSearchFilterList:[
                {
                    field_key: 'stock_type',
                    field_name: '入库类型',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'uid',
                    field_name: '发起人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'cancel_uid',
                    field_name: '处理人',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'cancel_at',
                    field_name: '取消入库日期',
                    field_value: '',
                    field_type: 'eq',
                },
                {
                    field_key: 'reason',
                    field_name: '取消原因',
                    field_value: '',
                    field_type: 'eq',
                },
            ],
            pendingTotal:0,
            inTypeList:[],
            stockList:[],
            userList:[],
            inCancelProductDetailDialog:false, //取消入库详情
            inColumnInfo:null, //选中的一条
            inProductDetailDialog:false, //入库详情
            inColumnId:0,//选中一条的id
            inCancelDialog:false,//取消入库
            purchaseDetailVisible:false, //采购详情
            relatedId:0,//关联id
        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 215 : 165;
        },
    },
    created() {
        this.getTableData()
        this.getStockList()
        this.getUserList()
        this.getInTypeList()
        EventBus.$on('inventoryInUpdated', this.handleClickSearch);
    },
    beforeDestroy() {
        EventBus.$off('inventoryInUpdated', this.handleClickSearch);
    },
    mounted() {

    },
    methods: {
        isValid(value){
            if (Array.isArray(value)) return value.length > 0
            if (typeof value === 'string') return value.trim() !== ''
            // 根据业务需求添加其他类型验证
            return (
                    value !== undefined &&
                    value !== null &&
                    value !== false &&
                    !Number.isNaN(value)
            )
        },
        handleClickTab(val){
            this.tableData = []
            this.pagination.pageNum = 1
            this.handleClickSearch()
        },
        getInTypeList(){
            getStockType({ type:'in'}).then((res) => {
                if (res.code == 200) {
                    this.inTypeList = res.data || [];
                }
            });
        },
        getUserList(keyword){
            GetUserList({ keyword }).then(res => {
                if (res.code === 200) {
                    this.userList = res.data
                }
            })
        },
        // 获取仓库列表
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        // 清空筛选条件
        handleClickReset(){
            if(this.activeName == 1){
                this.pendingSearchFilterList = JSON.parse(JSON.stringify(this.$options.data().pendingSearchFilterList))
            }else if(this.activeName == 2){
                this.alreadySearchFilterList = JSON.parse(JSON.stringify(this.$options.data().alreadySearchFilterList))
            }else{
                this.cancelSearchFilterList = JSON.parse(JSON.stringify(this.$options.data().cancelSearchFilterList))
            }
        },
        handleClickEnter(ref){
            this.$refs[ref].blur()
        },
        // 搜索
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },
        // 表头配置
        handleClickCustom() {
            if(this.activeName == 1){
                this.$refs.pendingTableRef.handleOpenCustomShow();
            }else if(this.activeName == 2){
                this.$refs.alreadyTableRef.handleOpenCustomShow();
            }else{
                this.$refs.cancelTableRef.handleOpenCustomShow();
            }
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val.pageSize
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                type:'in',
                sort:'desc'
            }
            if(this.activeName == 1){
                this.pendingSearchFilterList.forEach((item)=>{
                    if(item.field_key == 'date_range'){
                        if(item.field_value && item.field_value.length>0){
                            let startDate = item.field_value[0] + ' 00:00'
                            let endDate = item.field_value[1] + ' 23:59'
                            postData[item.field_key] = startDate + ' - ' + endDate
                        }else{
                            postData[item.field_key] = ''
                        }
                    }else{
                        postData[item.field_key] = item.field_value
                    }
                })
                postData.keyword = this.pending_keywords
                getPendingList(postData).then(res => {
                    if (res.code === 200) {
                        let {list, total} = res.data
                        this.tableData = list
                        this.pagination.total = total
                        this.pendingTotal = total
                    }
                    this.loading = false
                })
            }else if(this.activeName == 2){
                this.alreadySearchFilterList.forEach((item)=>{
                    if(item.field_key == 'date_range'){
                        if(item.field_value && item.field_value.length>0){
                            let startDate = item.field_value[0] + ' 00:00'
                            let endDate = item.field_value[1] + ' 23:59'
                            postData[item.field_key] = startDate + ' - ' + endDate
                        }else{
                            postData[item.field_key] = ''
                        }
                    }else{
                        postData[item.field_key] = item.field_value
                    }
                })
                postData.keyword = this.already_keywords
                getStockLogList(postData).then(res => {
                    if (res.code === 200) {
                        let {list, total} = res.data
                        this.tableData = list
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            }else if(this.activeName == 3){
                this.cancelSearchFilterList.forEach((item)=>{
                    if(item.field_key == 'cancel_at'){
                        if(item.field_value && item.field_value.length>0){
                            let startDate = item.field_value[0] + ' 00:00'
                            let endDate = item.field_value[1] + ' 23:59'
                            postData[item.field_key] = startDate + ' - ' + endDate
                        }else{
                            postData[item.field_key] = ''
                        }
                    }else{
                        postData[item.field_key] = item.field_value
                    }
                })
                postData.keyword = this.cancel_keywords
                getPendingCancelList(postData).then(res => {
                    if (res.code === 200) {
                        let {list, total} = res.data
                        this.tableData = list
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            }

        },
        // 新建入库
        handleClickAdd(){
            this.$router.push({
                name: 'InWarehouseAdd',
                query:{

                },
                params: {
                    isPush: true
                }
            })
        },
        // 审核入库
        handleClickInAudit(row){
            this.$router.push({
                name: 'InWarehouseAudit',
                query:{
                    stock_pending_id:row.stock_pending_id,
                    name:row.approval_set_name
                },
                params: {
                    isPush: true
                }
            })
        },
        // 取消入库
        handleClickInCancel(row){
            this.inColumnId = row.id
            this.inColumnInfo = row
            this.inCancelDialog = true
        },
        // 取消详情
        handleClickInCancelDetail(row){
            this.inColumnId = row.stock_pending_id
            this.inCancelProductDetailDialog = true
        },
        // 入库详情
        handleClickInDetail(row){
            this.inColumnId = row.id
            this.inProductDetailDialog = true
        },
        // 审批详情
        handleClickApprovalDetail(row) {
            this.$showApprovalDetail({
                approval_id: row.approval_id,
            }).then((res) => {
                console.log(res);
            });
        },
        // 关联详情
        handleClickRelatedDetail(row){
            if(row.related_info.related_type == 'purchase'){
                this.relatedId = row.related_info.related_id
                this.purchaseDetailVisible = true
            }else if(row.related_info.related_type == 'order'){
                this.$router.push({
                    name: "OrderDetail",
                    params: {
                        isPush: true,
                    },
                    query: {
                        order_id:row.related_info.related_id,
                        name:row.related_info.related_num,
                    },
                });
            }
        },
    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/inventory_management.scss";
::v-deep .el-button--default:active{
    border: 1px solid #DCDFE6 !important;
    color: #606266 !important;
}
::v-deep .el-button--default:focus{
    border: 1px solid #DCDFE6 !important;
    color: #606266 !important;
}
</style>